import {Button, FormControl} from "@/components";
import {userAnswerRequest} from "@/api/request";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {gameTimeSelector, userIDSelector} from "@/selectors";
import {deleteUnderscore, getTime} from "@/utils";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";

const MathScreenTwo = ({profitClickRef, handleProfitChange}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const userID = useSelector(userIDSelector);
    const time = useSelector(gameTimeSelector);
    const [profitInput, setProfitInput] = useState({text: "", helper: "", error: false, showMask: true});
    const profitRef = useRef(null);
    const btnRef = useRef(null);
    const disabledBtn = !deleteUnderscore(profitInput.text);

    useEffect(() => {
        profitRef.current.focus();
    }, []);

    return (
        <>
            <p className="left-side__text">
                <span>{t("You and your partner decide to start a company.")}</span>
                <span>{t("Your contribution is 1.5 times that of your partner.")}</span>
                <span>{t("Later you decided to invite another partner to your business.")}</span>
                <span>{t("But leave the amount of total contributions unchanged.")}</span>
                <span>{t("The new partner contributed 25K.")}</span>
                <span>{t("How much of this money should you get so that each partner's contribution is the same.")}</span>
            </p>
            <FormControl label={t("Enter answer")} info={profitInput} helper="">
                <InputMask alwaysShowMask={true}
                           className="form-control__input"
                           value={profitInput.text}
                           onChange={(e) => {
                               handleProfitChange(profitInput, setProfitInput, e)
                           }}
                           mask="999 K">
                    {inputProps =>
                        <input
                            ref={profitRef}
                            onKeyUp={(e) => {
                                profitClickRef(profitInput, profitRef, btnRef, setProfitInput, e)
                            }}
                            {...inputProps}
                        />}
                </InputMask>
            </ FormControl>
            <Button
                disabled={disabledBtn}
                handleClick={() => dispatch(userAnswerRequest({
                    id: userID,
                    number_task: 2,
                    task_answer: deleteUnderscore(profitInput.text),
                    spent_time: getTime(time)
                }))}
                innerRef={btnRef}
                className="btn btn-primary">{t("Next")}</Button>
        </>
    )
}

MathScreenTwo.propTypes = {
    profitClickRef: PropTypes.func.isRequired,
    handleProfitChange: PropTypes.func.isRequired
};

export default MathScreenTwo;
